<section fxLayout="column" fxLayoutAlign="center center">
  <h1>
    <span>体の悩みを根本からケア</span>
  </h1>
  <div>
    <p>五所川原で30年のカイロプラクティック・整体の実績をもつベテランの施術師により、</p>
    <p>お客様の体のお悩みを根本ケア、トータルサポート致します。</p>
  </div>
</section>
